export function numberFormat(number) {
    if (number) return String(number).replace(/\B(?=(\d{3})+(?!\d))\B/gmi, ",");
    else return number;
}
